const {
  GET_CONTAINERS,
  GET_CONTAINERS_SUCCESS,
  GET_CONTAINERS_ERROR,
  RESET_CONTAINER_FLAG,
} = require("./actionTypes")

const initialState = {
  type: "",
  containers: [],
  loading: false,
  error: "",
}

const containers = (state = initialState, action) => {
  switch (action.type) {
    case GET_CONTAINERS:
      return (state = { ...state, loading: true, containers: [] })
    case GET_CONTAINERS_SUCCESS:
      return (state = {
        ...state,
        loading: false,
        containers: action.payload.containers,
        type: action.payload.type,
        error: "",
      })
    case GET_CONTAINERS_ERROR:
      return (state = {
        ...state,
        loading: false,
        type: "",
        error: action.payload.error,
      })
    case RESET_CONTAINER_FLAG:
      return (state = {
        ...state,
        loading: false,
        containers: [],
        type: "",
        error: "",
      })
    default:
      return state
  }
}

export default containers
